import React, { useEffect, useRef, useState } from "react";
import {
  PatternlibStickySidebar,
  PatternlibStickySidebarItem,
} from "@liebherr/patternlib-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./Sticky.module.css";
import { pushToDataLayer } from "../../helpers/helpers";

function Sticky() {
  const { t, i18n } = useTranslation();

  const [productPage, setProductPage] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const locationRef = useRef();

  const navigationClickGA = (navigationArea, clickedElement) => {
    const eventName = "navigation_click";
    const pagePath = location.pathname;
    const pageType = "Home";
    const language =
      i18n.language === "de-DE" || i18n.language === "de" ? "de-DE" : "en-EN";
    const navigation_area = navigationArea;
    const clicked_element = clickedElement;
    let props = {
      pagePath,
      pageType,
      language,
      navigation_area,
      clicked_element,
    };

    pushToDataLayer(eventName, props);
  };

  const newTabPaths = [
    "/series260",
    "/series380",
    "/iso6022",
    "/summary/series260",
    "/summary/series380",
    "/summary/iso6022",
    "/downloads",
    "/finder",
  ];

  const shouldOpenInNewTab = () => {
    return newTabPaths.includes(locationRef.current);
  };

  const toPage = (tabId) => () => {
    let path;

    if (tabId === 0) {
      navigationClickGA("sidebar", t("Sidebar.contact"));
      path = "/contact";
    } else if (tabId === 1) {
      navigationClickGA("sidebar", t("Sidebar.myconfigs"));
      path = "/myconfigs";
    } else {
      path = "/";
    }

    shouldOpenInNewTab()
      ? window.open(`${window.location.origin}${path}`, "_blank")
      : navigate(path);
  };

  useEffect(() => {
    locationRef.current = location.pathname;
    if (newTabPaths.includes(locationRef.current)) {
      setProductPage(true);
    } else {
      setProductPage(false);
    }
  }, [location.pathname]);

  return (
    <div
      className={productPage ? styles.sidebarNoHeader : styles.sidebarDefault}
    >
      <PatternlibStickySidebar>
        <PatternlibStickySidebarItem
          icon-name="control-assistance-systems"
          label={t("Sticky.myConfigs")}
          item-id="myconfigs"
          onClick={toPage(1)}
        ></PatternlibStickySidebarItem>
        <PatternlibStickySidebarItem
          icon-name="phone"
          label={t("Sticky.contact")}
          item-id="contact"
          onClick={toPage(0)}
        ></PatternlibStickySidebarItem>
      </PatternlibStickySidebar>
    </div>
  );
}

export default Sticky;
